var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddInvertedRound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50065 13.5C2.91207 13.4961 0.00394093 10.5882 0 7.00001V6.87001C0.0714626 3.29795 3.01278 0.453183 6.58559 0.500584C10.1584 0.547984 13.0232 3.46978 12.9999 7.04248C12.9765 10.6152 10.0738 13.4993 6.50065 13.5ZM3.25032 6.35001V7.65001H5.85058V10.25H7.15071V7.65001H9.75097V6.35001H7.15071V3.75001H5.85058V6.35001H3.25032Z",
    fill: "#2C7BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddInvertedRound);
export default __webpack_public_path__ + "static/media/add-inverted-round.fa511477ab65e509511445fa6a757550.svg";
export { ForwardRef as ReactComponent };